import CRUDService from "./geral/CRUDService";
import {http} from "../config/Constantes";

export default class JustificativaContratacaoService extends CRUDService{
    constructor() {
        super("justificativacontratacao");
    }

    listByMotivo(motivo) {
        return http.get("/"+this.serviceName+"/motivo/"+motivo)
    }
}